import { ReactNode } from 'react';

interface KPIGridProps {
  children: ReactNode;
}

export default function KPIGrid({ children }: KPIGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
      {children}
    </div>
  );
}

